import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useUpdateFsResult = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const updateNIS = async (id, data) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
  const response = await axiosApi.put(`/nisfsResult/update/${id}`, data);
  setSuccess(response.data.message);
  return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Failed to update NIS record';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateNIS, isLoading, error, success };
};

export default useUpdateFsResult;